import { HttpClient, HttpParams } from "@angular/common/http";
import { Inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { APP_CONFIG } from "../lib/angular/injection-tokens";
import { IAppConfig } from "../lib/config/app-config";
import { OverallAssessmentResult } from "../_models/OverallAssessmentResult";
import { AppConstants } from "../constants/constants";
import { AssessmentProfileResult } from "../_models/AssessmentProfileResultDto";

@Injectable({
  providedIn: "root",
})
export class AssessmentProfileService {
  private baseUrl: string = this.config.protectedResourceEndpoint;
  private static readonly path: string = "AssessmentProfile/";
  private static readonly ASSESSMENT_PROFILE_RESULT: string = "learner/getassessmentprofileresult";

  constructor(private http: HttpClient, @Inject(APP_CONFIG) private config: IAppConfig) { }

  public getOverallAssessmentResultByCourse$(
    id
  ): Observable<OverallAssessmentResult> {
    return this.http.get<OverallAssessmentResult>(
      this.baseUrl + AssessmentProfileService.path + "mapped/" + id
    );
  }

  public getOverallAssessmentResultByLearnerId$(learnerId: number, courseId: number): Observable<OverallAssessmentResult> {
    let params: HttpParams = new HttpParams();
    params = params.append(AppConstants.LEARNER_ID, String(learnerId));
    params = params.append(AppConstants.COURSE_ID, String(courseId));
    
    return this.http.get<OverallAssessmentResult>(
      this.baseUrl +  AssessmentProfileService.path + "learner/mapped/",
      {params}
    );
  }

  public getAssessmentProfileResult$(learnerId: number, courseId: number): Observable<AssessmentProfileResult> {    
    return this.http.get<AssessmentProfileResult>(
      this.baseUrl +  
      AssessmentProfileService.path + 
      AssessmentProfileService.ASSESSMENT_PROFILE_RESULT + 
      AppConstants.SLASH +
      learnerId + 
      AppConstants.SLASH +
      courseId
    );
  }
}
